export interface Alert {
  name: string | null;
  tactic: number;
  severity: number;
  description: string | null;
  sensor: string | null;
  identicalTactic: number;
  numberOfEndpoints?: number;
  numberOfServers?: number;
  numberOfInternalEmails?: number;
  numberOfIps?: number;
  numberOfIdentities?: number;
}

export interface Alerts extends Array<Alert> {}

export const OPEN_GRAPH_EVENT_NAME = 'timeline-open-graph';
